import CoreNewsInsightsHero from './CoreNewsInsightsHero';

export { type CoreNewsInsightsHeroProps } from './CoreNewsInsightsHero';
export default CoreNewsInsightsHero;
